import React from 'react';
import bannerBg from '../../assets/images/dog-and-cat-background-banner.png';
import { Typography, TypographyProps } from '../../wag-react/components/Typography';
import { Flex } from '../../wag-react/next-components/Flex';
import { Grid } from '../../wag-react/core-components/grid';
import { theme } from '../../wag-react/themes/base-theme';
import { Banner, BannerProps } from '../../wag-react/components/banners';
import { Button, ButtonProps } from '../../wag-react/next-components/button';
export type NeedAdviceBannerProps = BannerProps & Pick<ButtonProps, 'href'> & {
  buttonProps?: ButtonProps;
  titleCopy?: string;
  titleCopyProps?: Omit<TypographyProps, 'children'>;
  subtitleCopy?: string;
  subtitleCopyProps?: Omit<TypographyProps, 'children'>;
  ctaCopy?: string;
};
export const NeedAdviceBanner = ({
  titleCopy = 'Need advice about your pet\'s health?',
  subtitleCopy = 'Get answers fast from a veterinary professional 24/7 in the Wag! App.',
  ctaCopy = 'Get Vet Chat',
  titleCopyProps,
  subtitleCopyProps,
  href,
  buttonProps,
  ...rest
}: NeedAdviceBannerProps) => <Banner as="figure" backgroundColor={theme.colors.funBlue} backgroundImage={`url(${bannerBg})`} backgroundRepeat="no-repeat" backgroundSize={['200px', 'contain']} backgroundPosition={['bottom right', 'right']} height={['280px', '200px']} px={['16px', '24px']} py={['16px', '24px']} m={0} {...rest} data-sentry-element="Banner" data-sentry-component="NeedAdviceBanner" data-sentry-source-file="index.tsx">
    <Grid gridTemplateColumns={['90%', '65% 35%']} height="100%" data-sentry-element="Grid" data-sentry-source-file="index.tsx">
      <Flex flexDirection="column" justifyContent={['start', 'space-between']} gridGap={['16px', 'initial']} data-sentry-element="Flex" data-sentry-source-file="index.tsx">
        <Typography fontFamily="muliBold" fontSize={['min(5vw, 26px)', '26px']} color={theme.colors.white} m={0} {...titleCopyProps} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {titleCopy}
        </Typography>
        <Typography fontSize={['min(4vw, 16px)', '18px']} color={theme.colors.white} m={0} {...subtitleCopyProps} data-sentry-element="Typography" data-sentry-source-file="index.tsx">
          {subtitleCopy}
        </Typography>
        <Button href={href} variant="contained" backgroundColor={theme.colors.buttermilk} color={theme.colors.shingleFawn} width="100%" maxWidth={['150px', '224px']} px={['16px', '24px']} fontFamily="muliBold" {...buttonProps} data-sentry-element="Button" data-sentry-source-file="index.tsx">
          {ctaCopy}
        </Button>
      </Flex>
    </Grid>
  </Banner>;